import jsPDF from "jspdf";

export var printerSKU = async (PrintNumber, currentSKU) => {
  var pdf = new jsPDF({
    orientation: "l",
    unit: "pt",
    format: [50, 160],
  });
  pdf.setFont("helvetica");
  //  pdf.setFontType("bold");
  pdf.setFontSize(14);
  var skus = [];

  for (var i = 0; i < PrintNumber; i++) {
    skus.push(currentSKU);
  }
  // var lastAdd = 140;
  // var k = 0;
  for (let i = 0; i < skus.length; i++) {
    pdf.text(skus[i], 10, 30);
    if (skus.length > i + 1) {
      pdf.addPage();
    }
    // console.log(i);
    // console.log("this is the module ==> ", i % 20);
    // if (i != 0 && i % 20 === 0) {
    //   pdf.addPage();
    //   k = 0;
    // }

    // if (lastAdd == 140) {
    //   pdf.text(20, 20 + (k / 3) * 40, skus[i] || "");
    //   lastAdd = 20;
    // }
    // if (lastAdd == 20) {
    //   pdf.text(80, 20 + (k / 3) * 40, skus[i + 1] || "");
    //   lastAdd = 80;
    // }
    // if (lastAdd == 80) {
    //   pdf.text(140, 20 + (k / 3) * 40, skus[i + 2] || "");
    //   lastAdd = 140;
    // }
    // k++;
  }
  pdf.save("SKU-" + currentSKU + ".pdf");
  pdf.autoPrint({ printDestination: "printer" });
  window.open(pdf.output("bloburl"), "_blank");
};
